export default {"src":"/_next/static/media/News.3b5d4991.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};